
const IndustrySpecificSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Industry-Specific Training
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              We recognize that different industries have unique safety challenges. For instance, construction sites often require training for rough terrain forklifts, while manufacturing environments may need training for cherry-picker style forklifts. Our hazard assessments help companies identify less obvious risks, such as machine guarding and respiratory protection, ensuring comprehensive safety coverage.
            </p>
            
            <p>
              Manufacturing companies may only sometimes recognize the hazards present in their work environment. While some hazards, like forklifts, are obvious, others, such as machine guarding, bloodborne pathogens, and respiratory protection, may be less apparent. Our team can help you identify these unseen hazards and provide the necessary training to protect your employees.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustrySpecificSection;